
/* ============================== src/utils/hourlyTask.js ============================== */
// path: frontend/src/utils/hourlyTask.js
/**
 * Чистые функции для live-валидации «часовой» задачи (задача с
 * фиксированным интервалом времени). Используются формой до отправки
 * на сервер: подсветить ошибки «конец раньше начала», невалидный
 * формат времени. Никакого applyHourlyMode здесь нет: сервер сам
 * проставляет deadline = start_date и planned_hours по
 * domain/hourly-task.ts::applyHourlyMode при create/update. Дублировать
 * это на клиенте — значит расходиться при изменении правила.
 */
const TIME_RE = /^(\d{1,2}):(\d{2})$/;

export const parseTimeToMinutes = (s) => {
  if (typeof s !== "string") return null;
  const m = TIME_RE.exec(s.trim());
  if (!m) return null;
  const h = Number(m[1]);
  const min = Number(m[2]);
  if (h > 23 || min > 59) return null;
  return h * 60 + min;
};

export const hoursBetween = (start, end) => {
  const s = parseTimeToMinutes(start);
  const e = parseTimeToMinutes(end);
  if (s === null || e === null || e <= s) return null;
  return (e - s) / 60;
};
